export const routes = (prefix) => [
    {
        path: `/${prefix}/wards/service-packages`,
        name: `${prefix}.wards.service-packages.index`,
        component: () => import('./service-packages/Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.wards.service-packages.index`,
                PageDescription: "Ward service package Listing/Create",
            },
        }
    },
    {
        path: `/${prefix}/wards/floors`,
        name: `${prefix}.wards.floors.index`,
        component: () => import('./floors/Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.wards.floors.index`,
                PageDescription: "Ward Floor Listing/Create",
            },
        }
    },
    {
        path: `/${prefix}/wards/setup`,
        name: `${prefix}.wards.setup.index`,
        component: () => import('./wards/Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.wards.setup.index`,
                PageDescription: "Ward Listing/Create",
            },
        }
    },
    {
        path: `/${prefix}/wards/beds`,
        name: `${prefix}.wards.beds.index`,
        component: () => import('./beds/Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.wards.beds.index`,
                PageDescription: "Bed Listing/Create",
            },
        }
    },
];
